import React, { Component } from 'react'

import { Card, CardHeading, CardContent } from '../layout/Card'
import { Projection } from '../Projection'
import { buildProjectionDatasets } from './data'

import { TimeValueToggle } from '../TimeValueToggle'

export default class ProjectionCharts extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showIncome: false,

      requiredProjection: translateMinimum(props.chartData.required_data),
      actualProjection: translateMinimum(props.chartData.actual_data),
      editedProjection: [],
      retirementAge: props.chartData.retirement_age
    }
  }


  toggleCharts = (evt) => {
    evt.preventDefault()

    this.setState({
      showIncome: !this.state.showIncome
    })
  }

  componentDidMount () {
    window.addEventListener('retirementScenarioUpdated', (e) => {
      this.setState({
        requiredProjection: translateMinimum(e.detail.chart_data.required_data),
        actualProjection: translateMinimum(e.detail.chart_data.actual_data),
        editedProjection: translateMinimum(e.detail.chart_data.edited_data),
        retirementAge: e.detail.chart_data.retirement_age
      })
    })
  }

  render () {
    // TODO: Fix, chart not updating correctly when props and state change
    const datasets = buildProjectionDatasets(this.state, this.props)
    return (
      <Card className='ui-card ui-card--projections-chart'>
          <CardHeading>
            <h5>{this.props.clientPronoun} {this.state.showIncome ? 'Income' : 'Capital'} Projection</h5>
            <div className='chart-actions pt-4 sm:pt-0'>
              <a className={this.state.showIncome ? '' : 'active'} onClick={this.toggleCharts}>
                <span className='hidden sm:inline-block'>View</span> Capital Growth Chart
              </a>
              <a className={this.state.showIncome ? 'active' : ''} onClick={this.toggleCharts}>
                <span className='hidden sm:inline-block'>View</span> Income Chart
              </a>
            </div>
          </CardHeading>
          <CardContent>
            <Projection
              datasets={datasets}
              colors={this.props.colors}
            />
          <div className='flex sm:hidden justify-center'>
            <TimeValueToggle
              usePresentValue={this.props.usePresentValue}
              setUsePresentValue={this.props.setUsePresentValue}
            />
          </div>
          </CardContent>
      </Card>
    )
  }
}

// NOTE: Should this function still be called?
// The calculation engine should handle minimums
const translateMinimum = (projection) => {
  return (projection || []).map((data_point) => {
    return Object.assign(data_point, {
      assets: Math.max(data_point.assets, 0),
      net_monthly_income: Math.max(data_point.net_monthly_income, 0)
    })
  })
}
